import React from 'react';
import { BaseAreaChart } from '../Common/AreaChart';
import { JsonPropsType } from '../../../component-loader';
import { ResponsiveWrapper } from '../Common/ResponsiveWrapper';

type ChartData = {
  date: string;
  bmk: number;
  pf: number
};

type Legends = {
  comparison: string;
  main: string;
};

export function HistoricalProfitChart(props: JsonPropsType) {
  const rawData = props.jsonObject as {
    data: ChartData[];
    legends: Legends;
  };
  const { legends, data } = rawData;
  const { comparison, main } = legends;
  return (
    <ResponsiveWrapper minHeight={350}>
      <BaseAreaChart<ChartData>
        margin={{
          left: -20, right: 0, top: 0, bottom: 0,
        }}
        data={data}
        dataKeys={['bmk', 'pf']}
        xAxisDataKey="date"
        legendLabels={{ bmk: main, pf: comparison }}
      />
    </ResponsiveWrapper>
  );
}
